import React from 'react'
import PropTypes from 'prop-types'
import { Card, Grid2 } from '@mui/material'
import Textarea from '../../../../components/forms/Textarea'
import i18n from '../../../../simple-react-i18n'
import { getSetting, isDeveloppmentEnv } from '../../../../utils/SettingUtils'
import NumberField from '../../../../components/forms/NumberField'
import Input from '../../../../components/forms/Input'
import SieauParameterDto from '../../../dto/SieauParameterDto'

const regexBase = {
    uppercase: '(?=(.*?[A-Z])',
    numeric: ')(?=(.*?[0-9])',
    special: ')(?=(.*?[^\\w\\s])',
    characters: ').',
    end: '$',
}
const regexType = ['uppercase', 'numeric', 'special', 'characters']

const SecurityPanel = ({
    applicationSettings = [],
    onChangeSettings = () => {},
    disabled = false,
}) => {
    const policy = getSetting(applicationSettings, 'passwordPolicy') || ''
    const regexSplit = policy.split(',}').map(e => e.split('{')[1])

    const parsePolicy = {
        uppercase: regexSplit[0],
        numeric: regexSplit[1],
        special: regexSplit[2],
        characters: regexSplit[3],
    }

    const onChangePolicy = (v, type) => {
        const regex = regexType.reduce((acc, t) => {
            const tmp = acc + regexBase[t]
            if (type === t) {
                return `${tmp}{${v && v !== 'undefined' ? v : 0},}`
            }
            return `${tmp}{${parsePolicy[t]},}`
        }, '') + regexBase.end
        onChangeSettings('passwordPolicy', regex)
    }

    return (
        <Card sx={{ padding: '0.5rem', borderRadius: '0 0 5px 5px' }}>
            <Grid2 container spacing={1}>
                { isDeveloppmentEnv() && (
                    <Grid2 size={12}>
                        <Input
                            title={ i18n.passwordPolicy }
                            value={ getSetting(applicationSettings, 'passwordPolicy') }
                            { ...disabled }
                        />
                    </Grid2>
                ) }
                <Grid2 size={12}>
                    <Textarea
                        title={ i18n.securityPasswordDescription }
                        value={ getSetting(applicationSettings, 'securityPasswordDescription') }
                        onChange={ (v) => onChangeSettings('securityPasswordDescription', v) }
                        { ...disabled }
                    />
                </Grid2>
                <Grid2 size={3}>
                    <NumberField
                        title={ i18n.minimumNumberCharacters }
                        min={ parseInt(parsePolicy.numeric) + parseInt(parsePolicy.uppercase) + parseInt(parsePolicy.special) }
                        value={ parsePolicy.characters }
                        onChange={ (v) => onChangePolicy(v, 'characters') }
                        { ...disabled }
                        dispatchOnNull
                    />
                </Grid2>
                <Grid2 size={3}>
                    <NumberField
                        title={ i18n.minimumNumberDigits }
                        min={0}
                        value={ parsePolicy.numeric }
                        onChange={ (v) => onChangePolicy(v, 'numeric') }
                        { ...disabled }
                        dispatchOnNull
                    />
                </Grid2>
                <Grid2 size={3}>
                    <NumberField
                        title={ i18n.minimumNumberUppercases }
                        min={0}
                        value={ parsePolicy.uppercase }
                        onChange={ (v) => onChangePolicy(v, 'uppercase') }
                        { ...disabled }
                        dispatchOnNull
                    />
                </Grid2>
                <Grid2 size={3}>
                    <NumberField
                        title={ i18n.minimumNumberSpecials }
                        min={0}
                        value={ parsePolicy.special }
                        onChange={ (v) => onChangePolicy(v, 'special') }
                        { ...disabled }
                        dispatchOnNull
                    />
                </Grid2>
                <Grid2 size={3}>
                    <NumberField
                        title={ i18n.maximumNumberTry }
                        value={ parseInt(getSetting(applicationSettings, 'maximumNumberTry') || 5) }
                        onChange={ (v) => onChangeSettings('maximumNumberTry', v ? v.toString() : '5') }
                        { ...disabled }
                    />
                </Grid2>
            </Grid2>
        </Card>
    )
}

SecurityPanel.propTypes = {
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    onChangeSettings: PropTypes.func,
    disabled: PropTypes.shape({
        active: PropTypes.bool,
        disabled: PropTypes.bool,
    }),
}

export default SecurityPanel